var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7162 22.0657L14.6225 25.582L3.68243 29.8174L0.584151 31.0174C0.105773 31.2071 -0.126709 31.7498 0.0700074 32.2218C0.168366 32.4689 0.369552 32.6542 0.619919 32.7469L5.86419 34.5381C5.91784 34.1057 6.17268 33.7219 6.5527 33.5057L19.232 26.3055C19.46 26.182 19.7461 26.2614 19.8668 26.4864C19.9741 26.6717 19.9339 26.9011 19.7774 27.0467L10.6122 35.1822C10.5317 35.266 10.0891 35.6058 10.0534 35.7249L8.03255 40L12.3692 36.7573C12.9862 36.9646 18.1143 38.7206 18.8654 38.972C19.3527 39.1397 19.8892 38.8838 20.0591 38.3985C20.0591 38.3897 20.0591 38.3853 20.0635 38.3808L24.9546 23.2084C25.0664 22.8686 24.968 22.4936 24.6998 22.251C24.4405 22.0039 24.056 21.9333 23.7207 22.0657H23.7162Z",
    fill: "url(#paint0_linear_4194_102553)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6415 23.6133C39.6415 23.6133 38.248 22.7111 38.0602 21.68C37.7632 20.0667 37.5972 18.08 37.5142 16L27 20.5378V34.3022C27 35.2356 27.7513 36 28.6686 36H39.3314C40.2487 36 41 35.2356 41 34.3022V26.2978C41 25.3644 40.3885 24.1556 39.6415 23.6133Z",
    fill: "url(#paint1_linear_4194_102553)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9817 2.51284C38.1186 1.59748 37.4736 0.849347 36.546 0.849347H28.6652C27.7375 0.849347 26.9777 0.959365 26.9777 1.09579C26.9777 1.23221 26.2444 1.1442 25.3476 0.902154C25.3476 0.902154 22.0212 0 19.1896 0C13.5706 0 8.96752 1.7163 5.38051 5.14889C1.7935 8.58149 0 13.0307 0 18.4832C0 21.8234 0.768643 24.9039 2.30152 27.7248C2.7521 28.5477 3.33963 29.3531 3.85648 30L14.6661 25.7753C14.6661 25.7753 13.8533 24.9567 13.5617 24.5827C12.2453 22.8928 11.5429 20.8816 11.5429 18.4832C11.5429 16.0848 12.2144 14.122 13.5617 12.4542C14.9046 10.7863 16.7821 9.95013 19.1896 9.95013C20.7004 9.95013 22.1758 10.2098 23.616 10.7247C25.0561 11.2395 25.8247 11.9657 25.8247 11.9657C26.5006 12.6038 27.0528 13.88 27.0528 14.8042V20.8068L37.6857 16.3136C37.4251 9.87971 37.9861 2.50843 37.9861 2.50843L37.9817 2.51284Z",
    fill: "#BFD730"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4194_102553",
    x1: 17.5465,
    y1: 39.7441,
    x2: 5.63007,
    y2: 9.85403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#020F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0066B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4194_102553",
    x1: 36.9376,
    y1: 37.1156,
    x2: 20.5178,
    y2: -2.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#020F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0066B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1bf85a199ee52c76acbc2e6926e67c63.svg";
export { ForwardRef as ReactComponent };